import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/navbar.css";

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [hidden, setHidden] = useState(false);
    const lastScrollY = useRef(0);

    const navLinks = [
        { label: "Home", path: "/" },
        { label: "About", path: "/about" },
        { label: "Services", path: "/services" },
        { label: "Contact", path: "/contact" },
    ];

    useEffect(() => {
        const handleScroll = () => {
            const current = window.scrollY;
            setScrolled(current > 60);
            // Hide on scroll down, reveal on scroll up
            if (current > lastScrollY.current && current > 120) {
                setHidden(true);
            } else {
                setHidden(false);
            }
            lastScrollY.current = current;
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Close menu on route change
    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    // Prevent body scroll when menu open
    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [menuOpen]);

    return (
        <>
            <nav className={`nb-root ${scrolled ? "nb-scrolled" : "nb-top"} ${hidden && !menuOpen ? "nb-hidden" : ""}`}>

                {/* ── LEFT: Logo ── */}
                <button className="nb-logo" onClick={() => navigate("/")} aria-label="Home">
                    <img src="/assets/minilogo.png" alt="King & Queen" />
                    <div className="nb-logo-text">
                        <span className="nb-logo-name">King &amp; Queen</span>
                        <span className="nb-logo-sub">Salon &amp; Studio</span>
                    </div>
                </button>

                {/* ── CENTER: Nav links (desktop) ── */}
                <ul className="nb-links">
                    {navLinks.map((l) => (
                        <li key={l.path}>
                            <Link
                                to={l.path}
                                className={`nb-link ${location.pathname === l.path ? "nb-active" : ""}`}
                            >
                                {l.label}
                                <span className="nb-link-line" />
                            </Link>
                        </li>
                    ))}
                </ul>

                {/* ── RIGHT: CTA + Hamburger ── */}
                <div className="nb-right">
                    <button
                        className="nb-cta"
                        onClick={() => navigate("/contact")}
                    >
                        Book a Slot
                    </button>

                    <button
                        className={`nb-burger ${menuOpen ? "nb-burger-open" : ""}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Menu"
                        aria-expanded={menuOpen}
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>

            </nav>

            {/* ── MOBILE MENU OVERLAY ── */}
            <div
                className={`nb-mobile-overlay ${menuOpen ? "nb-overlay-open" : ""}`}
                onClick={() => setMenuOpen(false)}
            />

            <div className={`nb-mobile-menu ${menuOpen ? "nb-mobile-open" : ""}`}>
                <div className="nb-mobile-brand">
                    <img src="/assets/minilogo.png" alt="King & Queen" className="nb-mobile-logo" />
                    <span className="nb-mobile-brand-name">King &amp; Queen</span>
                </div>

                <ul className="nb-mobile-links">
                    {navLinks.map((l, i) => (
                        <li
                            key={l.path}
                            style={{ transitionDelay: menuOpen ? `${0.06 * i}s` : "0s" }}
                            className={`nb-mobile-link-item ${menuOpen ? "nb-mobile-link-visible" : ""}`}
                        >
                            <Link
                                to={l.path}
                                className={`nb-mobile-link ${location.pathname === l.path ? "nb-mobile-active" : ""}`}
                                onClick={() => setMenuOpen(false)}
                            >
                                <span className="nb-mobile-num">0{i + 1}</span>
                                {l.label}
                            </Link>
                        </li>
                    ))}
                </ul>

                <div className="nb-mobile-footer">
                    <button
                        className="nb-mobile-cta"
                        onClick={() => { navigate("/contact"); setMenuOpen(false); }}
                    >
                        Book a Slot →
                    </button>
                    <p className="nb-mobile-tagline">Unisex Family Salon &amp; Bridal Studio</p>
                </div>
            </div>
        </>
    );
};

export default Navbar;